/** Verde so quando a mensagem sai de fato; ambar enquanto depende de terceiro. */
export const TONE_BADGE: Record<string, string> = {
  ok: 'border-emerald-500/50 text-emerald-700 dark:text-emerald-400',
  wait: 'border-amber-500/50 text-amber-700 dark:text-amber-400',
  bad: 'border-destructive/50 text-destructive',
  none: '',
};

export const TONE_CIRCLE: Record<string, string> = {
  ok: 'bg-emerald-500/10 text-emerald-600 dark:text-emerald-400',
  wait: 'bg-amber-500/10 text-amber-600 dark:text-amber-400',
  bad: 'bg-destructive/10 text-destructive',
  none: 'bg-muted text-muted-foreground',
  info: 'bg-primary/10 text-primary',
};
